import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormPaintwork({
  paintworkSelect,
  callback,
  title,
  button_text,
  button_variant,
}) {
  const [show, setShow] = useState(false);
  const [infoForm, setForm] = useState({
    name: '',
    state: true,
  });

  const handleClose = () => setShow(false);
  const handleShow = async (paintwork) => {
    if (paintwork) {
      const infopaintwork = await get('/config/paintwork/' + paintwork);
      if (infopaintwork.success) {
        const { name, state } = infopaintwork.data;
        setForm({
          name,
          state,
        });
      }
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';

    const body = {
      name: infoForm.name,
      state: infoForm.state,
    };
    if (paintworkSelect) {
      respo = await put(
        '/config/paintwork/modify/' + paintworkSelect,
        body,
      );
      msg = 'Novedad editado Correctamente';
    } else {
      respo = await post('/config/paintwork/create', body);
      msg = 'Novedad Creado Correctamente';
    }

    if (respo.success) {
      variant = 'success';
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    setForm({
      name: '',
      state: true,
    });
    handleClose();
    callback(variant, msg);
  };

  useEffect(() => {
    const initForm = () => {};

    initForm();
  }, []);

  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(paintworkSelect)}
      />

      <Modal animation={false}  fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form.Label htmlFor="nombre">Nombre</Form.Label>
            <Form.Control
              name="name"
              value={infoForm.name}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Check
            className='mb-4'
              type="switch"
              name="state"
              label="Activo"
              checked={infoForm.state}
              onChange={(e) => handleForm(e)}
            />   

           
            <Row className="text-center m-3">
              <Col>
                <Button variant="secondary">Limpiar Formulario</Button>
              </Col>
              <Col>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={(e) => saveForm(e)}
                >
                  Guardar Informacion
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormPaintwork;
